import { createFormHook } from '@tanstack/react-form';
import { fieldContext, formContext } from './form-context.hook';
import { QuoteFormFields } from './form-fields';

const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField: QuoteFormFields.TextField,
    TextareaField: QuoteFormFields.TextareaField,
    NumberField: QuoteFormFields.NumberField,
    DateField: QuoteFormFields.DateField,
    CheckboxField: QuoteFormFields.CheckboxField,
    SelectField: QuoteFormFields.SelectField,
    RadioButtonGroup: QuoteFormFields.RadioButtonGroup,
    RadioCardField: QuoteFormFields.RadioCardField,
    CalendarField: QuoteFormFields.CalendarField,
  },
  formComponents: {},
});

export { useAppForm as useQuoteForm, withForm };
